import { render, staticRenderFns } from "./CookeModalBtn.vue?vue&type=template&id=0b624695&"
import script from "./CookeModalBtn.vue?vue&type=script&lang=js&"
export * from "./CookeModalBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/banner/components/CookeModalBtn.vue
// module id = 1214
// module chunks = 0